import { userApi, UserApi } from './user';

export { userApi, UserApi };



// WEBPACK FOOTER //
// ./src/api/user/index.ts